import { render } from "./detail-hard-copy.vue?vue&type=template&id=5a3000a0&scoped=true"
import script from "./detail-hard-copy.vue?vue&type=script&lang=js"
export * from "./detail-hard-copy.vue?vue&type=script&lang=js"

import "./detail-hard-copy.vue?vue&type=style&index=0&id=5a3000a0&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3000a0"]])

export default __exports__